// extracted by mini-css-extract-plugin
export var action = "Footer-module--action--29358";
export var bold = "Footer-module--bold--2e88f";
export var bottom = "Footer-module--bottom--72f69";
export var bottomBox = "Footer-module--bottomBox--0b04e";
export var box = "Footer-module--box--565ff";
export var copyright = "Footer-module--copyright--0ba15";
export var cta = "Footer-module--cta--d9358";
export var image = "Footer-module--image--6d872";
export var logo = "Footer-module--logo--b0f4f";
export var logoMobile = "Footer-module--logoMobile--436d0";
export var navBox = "Footer-module--navBox--2a245";
export var root = "Footer-module--root--93a12";
export var socialLinks = "Footer-module--socialLinks--b0fcb";
export var spacer = "Footer-module--spacer--05811";
export var title = "Footer-module--title--9aafd";
export var train = "Footer-module--train--3a2b3";
export var trainBox = "Footer-module--trainBox--5da3a";